import React, {useEffect, useState} from "react";
import Book from "../book/book";
import {getCourseById, getUserFromJWT, validateJWT, setWizportalAuth} from "../../service/blended_wizportal";
import {useParams} from "react-router-dom";
import {loginManager} from "../../service/service";
import {useAppGlobalConfig} from "../../providers/AppGlobalConfigContext";

export function EmbeddableCoursePage () {

    const {setEmbedMode} = useAppGlobalConfig();

    const { jwt } = useParams();

    const [courseLoading, setCourseLoading] = useState(true);
    const [course, setCourse] = useState(null);
    const [userInfo, setUserInfo] = useState(null);
    const [authError, setAuthError] = useState(false);

    useEffect(() => {
        async function doLogin() {
            try {

               const {token, user} =
                   await loginManager({jwtToken: jwt}, validateJWT, (d) => {
                        return Promise.resolve(getUserFromJWT(jwt))
                   })

                if (user) {
                    setWizportalAuth(token.token_type, token.access_token);
                    setUserInfo(user);
                    setEmbedMode(true);
                } else {
                    console.error('Token verification failed');
                    setAuthError(true);
                }
            } catch (err) {
                console.error('Error validating token:', err);
                setAuthError(true);
            } finally {
                setCourseLoading(false);
            }
        }

        doLogin().then(() => {
            console.log('Login done');
        });

    }, [jwt]);  // Add 'jwt' to the dependency array


    useEffect(() => {

        if(userInfo) {
            let courseId = userInfo.book;

            getCourseById(courseId).then(res => setCourse(res.data))
                .catch(err => console.log('error courses: ', err))
                .finally(() => setCourseLoading(false));
        }

    }, [userInfo]);

    if(authError) {
        return (
            <div className="card" style={{marginBottom: 50, border: "none", background: 'none'}}>
                <div className="home-no-lessons">
                    Authentication error.
                </div>
            </div>
        )
    }

    return (
      <div className="card" style={{marginBottom: 50, border: "none", background: 'none'}}>
          <div>
              {courseLoading && (
                  <div className="loading-lessons-container">
                      <div className="spinner-border home-loading" role="status">
                          <span className="sr-only">Loading...</span>
                      </div>
                      <div style={{color: 'rgb(117,117,117)'}}>
                         Loading...
                      </div>
                  </div>
              )}

              {!course && !courseLoading ? (
                  <div className="home-no-lessons">
                      No lessons available.
                  </div>
              ) : (
                  course && (
                      <div className="all-lessons-container">
                          <Book
                              hiddenBanner={true}
                              currentBook={course}
                              courses={[course]}
                              changeBook={()=>{}}
                              currentLanguage={"en"}
                          />
                      </div>
                  )
              )}
          </div>
      </div>
    );
}